import { graphql } from "react-relay";

export const QUERY = graphql`
	query featureTogglesScreen_Query {
		...featureTogglesScreen_QueryFragment
	}
`;

export const EDIT_FEATURE_TOGGLE_MUTATION = graphql`
	mutation featureTogglesScreen_EditFeatureToggleMutation($input: EditFeatureToggleDataInput!) {
		Admin {
			FeatureToggle {
				editFeatureToggle(input: $input) {
					featureToggle {
						id
						data {
							kind
							... on TimeBasedLicensesFeatureToggleData {
								name
								isActive
								kind
							}
							... on SplitCourseCertificationFeatureToggleData {
								name
								isActive
								kind
							}
							... on AbandonedCartReminderFeatureToggleData {
								name
								isActive
								kind
							}
							... on CourseRecommendationsFeatureToggleData {
								name
								isActive
								kind
							}
							... on ScheduledGlobalDiscountFeatureToggleData {
								name
								isActive
								kind
							}
							... on SecciDownloadCheckoutFeatureToggleData {
								name
								isActive
								kind
							}
							... on SignupMarketingOptInFeatureToggleData {
								name
								isActive
								kind
							}
							... on InProductExpressCheckoutFeatureToggleData {
								name
								isActive
								kind
							}
							... on ProfileEnrichmentSetNameFeatureToggleData {
								name
								isActive
								kind
							}
							... on StoryblokCampaignsFeatureToggleData {
								name
								isActive
								kind
							}
							... on PaymentProviderInvoiceNoticeFeatureToggleData {
								name
								isActive
								kind
							}
							... on NoConsentOrderAttributionFeatureToggleData {
								name
								isActive
								kind
							}
						}
					}
					clientMutationId
				}
			}
		}
	}
`;

export const QUERY_FRAGMENT = graphql`
	fragment featureTogglesScreen_QueryFragment on Query
	@refetchable(queryName: "featureTogglesScreen_Refetch")
	@argumentDefinitions(first: { type: "Int" }, after: { type: "String" }) {
		Admin {
			FeatureToggle {
				featureToggles(first: $first, after: $after)
					@connection(key: "featureTogglesScreen_QueryFragment__featureToggles") {
					__id
					pageInfo {
						endCursor
						hasPreviousPage
						hasNextPage
						startCursor
					}
					edges {
						node {
							...featureTogglesScreen_FeatureToggleFragment
						}
					}
				}
			}
		}
	}
`;

export const FEATURE_TOGGLE_FRAGMENT = graphql`
	fragment featureTogglesScreen_FeatureToggleFragment on FeatureToggle @inline {
		id
		data {
			kind
			... on TimeBasedLicensesFeatureToggleData {
				name
				isActive
			}
			... on SplitCourseCertificationFeatureToggleData {
				name
				isActive
			}
			... on AbandonedCartReminderFeatureToggleData {
				name
				isActive
				kind
			}
			... on ExperimentalModeFeatureToggleData {
				name
				isActive
			}
			... on CourseRecommendationsFeatureToggleData {
				name
				isActive
			}
			... on ScheduledGlobalDiscountFeatureToggleData {
				name
				isActive
			}
			... on SecciDownloadCheckoutFeatureToggleData {
				name
				isActive
			}
			... on SignupMarketingOptInFeatureToggleData {
				name
				isActive
			}
			... on InProductExpressCheckoutFeatureToggleData {
				name
				isActive
			}
			... on ProfileEnrichmentSetNameFeatureToggleData {
				name
				isActive
			}
			... on StoryblokCampaignsFeatureToggleData {
				name
				isActive
			}
			... on PaymentProviderInvoiceNoticeFeatureToggleData {
				name
				isActive
			}
			... on NoConsentOrderAttributionFeatureToggleData {
				name
				isActive
			}
		}
		__typename
	}
`;
